import { Chip } from "@mui/material";
import { getToolName } from "ai";
import ChartRenderer from "./ChartRenderer";
import KpiRenderer from "./KpiRenderer";
import MarkdownRenderer from "./MarkdownRenderer";
import TableRenderer from "./TableRenderer";
import { getRenderableToolInput, HIDDEN_TOOL_NAMES, RENDER_TOOL_NAMES } from "./messageUtils";

function HiddenToolDebug({ toolName, state, input }) {
  if (process.env.NODE_ENV !== "development") {
    return null;
  }

  return (
    <details style={{ fontSize: "0.7rem", color: "#64748b", marginTop: 8 }}>
      <summary>
        tool: {toolName} ({state})
      </summary>
      <pre style={{ margin: "4px 0 0", whiteSpace: "pre-wrap" }}>{JSON.stringify(input, null, 2)}</pre>
    </details>
  );
}

export default function ToolPartRenderer({ part }) {
  const toolName = getToolName(part);
  const input = getRenderableToolInput(part);

  if (!input && part.state === "input-streaming") {
    if (HIDDEN_TOOL_NAMES.has(toolName)) {
      return (
        <Chip
          size="small"
          label="Thinking..."
          sx={{ mt: 1, height: 22, fontSize: "0.7rem" }}
          color="default"
          variant="outlined"
        />
      );
    }
    return null;
  }

  if (!input) {
    return null;
  }

  if (toolName === "render_chart") {
    return <ChartRenderer key={part.toolCallId} {...input} />;
  }

  if (toolName === "render_kpi") {
    return <KpiRenderer key={part.toolCallId} {...input} />;
  }

  if (toolName === "render_table") {
    return <TableRenderer key={part.toolCallId} {...input} />;
  }

  if (toolName === "render_markdown") {
    return <MarkdownRenderer key={part.toolCallId} content={input.content} variant={input.variant} />;
  }

  if (toolName === "ask_clarification") {
    return null;
  }

  if (toolName === "__assistant_status__") {
    return null;
  }

  if (RENDER_TOOL_NAMES.has(toolName)) {
    return null;
  }

  return <HiddenToolDebug toolName={toolName} state={part.state} input={input} />;
}
